import capitalize from 'lodash/capitalize'

const addUtmParams = ({
  link,
  method = 'Share',
  channel,
  source,
}: {
  link: string
  method?: string
  channel: string
  source: string
}) =>
  `${link}?utm_campaign=${method}&utm_medium=${capitalize(
    channel,
  )}&utm_source=${source}`

export default addUtmParams
